// import { scroller } from 'react-scroll';
// import copy from 'copy-to-clipboard';
import * as clipboard from 'clipboard-polyfill';
import htmlToText from 'html-to-text';

import {
    COPY_TO_CLIPBOARD_REQUESTED,
    COPY_TO_CLIPBOARD_COMPLETED,
    COPY_TO_CLIPBOARD_ERROR,
} from './types';

const copyToClipboardAction = async () => async (dispatch, getState) => {
    dispatch({
        type: COPY_TO_CLIPBOARD_REQUESTED,
    });

    const {
        selectedsections,
    } = getState();

    let markup = '';
    let plain = '';
    selectedsections.get('selectedsections').forEach((item) => {
        markup += `${item.content}<p>&nbsp;</p>`;
        plain += `${htmlToText.fromString(item.content)}\n\n`;
    });
    if (markup.length > 0) {
        const item = new clipboard.ClipboardItem({
            'text/html': new Blob(
                [markup],
                { type: 'text/html' },
            ),
            'text/plain': new Blob(
                [plain],
                { type: 'text/plain' },
            ),
        });
        await clipboard.write([item]);

        // copy(data, {
        //    debug: process.env.REACT_APP_DEBUG,
        //    format: 'text/html',
        // });
        window.setTimeout(() => {
            dispatch({
                type: COPY_TO_CLIPBOARD_COMPLETED,
            });
        }, 1500);
        return;
    }
    dispatch({
        type: COPY_TO_CLIPBOARD_ERROR,
    });

};

export default copyToClipboardAction;
